export const CHECK_NAME_SUCCESS = 'CHECK_NAME_SUCCESS'
export const CHECK_NAME_FAIL = 'CHECK_NAME_FAIL'
export const CLEAR_MESSAGE = 'CLEAR_MESSAGE'
export const CLEAR_ERRORS = 'CLEAR_ERRORS'
export const SETUP_SUCCESS = 'SETUP_SUCCESS'
export const SETUP_FAIL = 'SETUP_FAIL'
export const SET_COUNT = 'SET_COUNT'
export const RESET_COUNT = 'RESET_COUNT'
export const IS_SUBMITTING = 'IS_SUBMITTING'
export const CLEAR_SETUP = 'CLEAR_SETUP'